import React from "react";
import { LinkedinShareButton, LinkedinIcon } from "react-share";

export const QHLinkedinShareButton = ({url}) => {
  return (
    <LinkedinShareButton url={url}>
      <p className="sr-only">Share article to LinkedIn (opens in a new tab)</p>
      <LinkedinIcon size={25} borderRadius="15" />
    </LinkedinShareButton>
  );
};